import React, { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { PopupButtonMessage } from 'components';
import { startTrial } from 'store/actionCreators/subscriptions';
import { selectIsStartingTrial } from 'store/selectors/subscriptions';
import { ReactComponent as RocketLaunchIcon } from 'static/images/rocket_launch.svg';

import { BtnPrimary, BtnSpinner, InfoNote } from './styled';

type StartTrialControlProps = {
  errorMessage?: string | null;
};

type TrialStartButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading?: boolean;
};

const TrialStartButton = ({
  isLoading = false,
  disabled,
  ...props
}: TrialStartButtonProps) => {
  const { t } = useTranslation();
  return (
    <BtnPrimary
      type="button"
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading ? (
        <BtnSpinner aria-hidden />
      ) : (
        <RocketLaunchIcon width={18} height={18} aria-hidden />
      )}
      {t('subscriptions.startTrial')}
    </BtnPrimary>
  );
};

const StartTrialControl = ({ errorMessage }: StartTrialControlProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isStartingTrial = useSelector(selectIsStartingTrial);

  return (
    <>
      {isStartingTrial ? (
        <TrialStartButton isLoading />
      ) : (
        <PopupButtonMessage
          popupHeaderText={t('subscriptions.startTrialHeader')}
          popupMessageText={t('subscriptions.startTrialText')}
          popupButtonText={t('subscriptions.startTrialPopupButton')}
          ButtonComponent={TrialStartButton}
          onConfirm={() => dispatch(startTrial())}
        />
      )}
      {errorMessage ? <InfoNote role="alert">{errorMessage}</InfoNote> : null}
    </>
  );
};

export default StartTrialControl;
